import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { Box, Typography, Alert } from '@mui/material';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { isAuthenticated, user } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) {
    // Send logged-out visitors to the admin sign-in (not the marketing landing),
    // so a bookmark/deep-link to /admin still reaches the admin login.
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  const isSuperAdmin = user?.role === 'super_admin' || user?.is_admin === true;
  if (!isSuperAdmin) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        px={3}
      >
        <Alert severity="error" sx={{ maxWidth: 600 }}>
          <Typography variant="h6" gutterBottom>
            Access Denied
          </Typography>
          <Typography variant="body2">
            You don't have administrator privileges to access this area.
            Please contact your system administrator if you believe this is an error.
          </Typography>
        </Alert>
      </Box>
    );
  }

  return <>{children}</>;
};

export default AdminRoute;